import { Link } from "react-router-dom"
import { config } from "../lib/config"

export const Footer = () => {
  const year = new Date().getFullYear()

  return (
    <footer className="border-t border-slate-200 bg-white">
      <div className="mx-auto grid max-w-6xl gap-8 px-4 py-10 sm:px-6 md:grid-cols-3">
        <div>
          <p className="text-lg font-semibold text-slate-900">{config.appName}</p>
          <p className="mt-2 text-sm text-slate-600">
            Motor fiscal SaaS — API + painel multiempresa com auditoria total.
          </p>
        </div>
        <div>
          <p className="text-sm font-semibold text-slate-900">Links</p>
          <ul className="mt-3 space-y-2 text-sm text-slate-600">
            <li>
              <a href={config.publicUrl} className="hover:text-brand-600">
                {config.publicUrl.replace(/^https?:\/\//, "")}
              </a>
            </li>
            <li>
              <a href={`mailto:${config.supportEmail}`} className="hover:text-brand-600">
                {config.supportEmail}
              </a>
            </li>
            <li>
              <Link to="/desenvolvedores" className="hover:text-brand-600">
                Documentação API
              </Link>
            </li>
            <li>
              <Link to="/termos" className="hover:text-brand-600">
                Termos de uso
              </Link>
            </li>
            <li>
              <Link to="/privacidade" className="hover:text-brand-600">
                Privacidade
              </Link>
            </li>
          </ul>
        </div>
        <div>
          <p className="text-sm font-semibold text-slate-900">Suporte</p>
          <p className="mt-3 text-sm text-slate-600">
            Dúvidas comerciais ou técnicas:{" "}
            <a href={`mailto:${config.supportEmail}`} className="font-medium text-brand-600 hover:underline">
              {config.supportEmail}
            </a>
          </p>
        </div>
      </div>
      <div className="border-t border-slate-100 py-4 text-center text-xs text-slate-500">
        © {year} MundoApps — {config.appName}
      </div>
    </footer>
  )
}
